import { Copy } from "lucide-react";

export const MailDnsRecords = ({ records, onCopy }) => (
  <div className="overflow-x-auto border border-slate-200 rounded-xl" data-testid="mail-dns-records">
    <table className="w-full text-xs">
      <thead className="bg-slate-50 text-slate-500"><tr>{["Type", "Name", "Value", "Priority", "Status"].map((h) => <th key={h} className="text-left px-3 py-2 font-semibold">{h}</th>)}</tr></thead>
      <tbody className="divide-y divide-slate-100">
        {records.map((r, i) => (
          <tr key={i}>
            <td className="px-3 py-2 font-mono">{r.type}</td>
            <td className="px-3 py-2 font-mono">{r.name || "@"}</td>
            <td className="px-3 py-2 font-mono max-w-[320px]">
              <button onClick={() => onCopy(r.value)} className="flex items-center gap-1.5 text-left hover:text-[#F5551E]" data-testid={`mail-dns-copy-${i}`}>
                <span className="truncate">{r.value}</span><Copy size={12} className="shrink-0" /></button>
            </td>
            <td className="px-3 py-2">{r.priority ?? ""}</td>
            <td className={`px-3 py-2 font-semibold ${r.status === "verified" ? "text-emerald-600" : "text-amber-600"}`}>{r.status}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
